// frontend/app/src/features/feedback/ui/forms/SuggestionForm.jsx
import React, { useState } from 'react';
import { feedbackApi } from '../../api/feedback.api';

const SuggestionForm = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    title: '',
    category: 'feature',
    priority: 'medium',
    description: '',
    benefits: '',
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      await feedbackApi.submitSuggestion(formData);
      setStatus({ type: 'success', message: 'ПРЕДЛОЖЕНИЕ УСПЕШНО ОТПРАВЛЕНО! СПАСИБО.' });
      if (onSuccess) setTimeout(onSuccess, 2000);
    } catch (error) {
      const serverError = error.response?.data;
      let errorMsg = 'ОШИБКА ОТПРАВКИ. ПОПРОБУЙТЕ ПОЗЖЕ.';
      
      if (serverError) {
        if (typeof serverError === 'object') {
          errorMsg = Object.entries(serverError)
            .map(([field, msgs]) => `${field.toUpperCase()}: ${Array.isArray(msgs) ? msgs.join(' ') : msgs}`)
            .join(' | ');
        } else if (typeof serverError === 'string') {
          errorMsg = serverError;
        }
      }
      
      setStatus({ type: 'error', message: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="feedback-form">
      <div className="form-group">
        <label>ЗАГОЛОВОК</label>
        <input
          name="title"
          value={formData.title}
          onChange={handleChange}
          placeholder="КРАТКАЯ СУТЬ ИДЕИ"
          required
        />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
        <div className="form-group">
          <label>КАТЕГОРИЯ</label>
          <select name="category" value={formData.category} onChange={handleChange}>
            <option value="gameplay">ГЕЙМПЛЕЙ</option>
            <option value="feature">НОВЫЙ ФУНКЦИОНАЛ</option>
            <option value="ui_ux">ИНТЕРФЕЙС</option>
            <option value="community">СООБЩЕСТВО</option>
            <option value="technical">ТЕХНИЧЕСКИЕ УЛУЧШЕНИЯ</option>
            <option value="other">ДРУГОЕ</option>
          </select>
        </div>
        <div className="form-group">
          <label>ПРИОРИТЕТ</label>
          <select name="priority" value={formData.priority} onChange={handleChange}>
            <option value="low">НИЗКИЙ</option>
            <option value="medium">СРЕДНИЙ</option>
            <option value="high">ВЫСОКИЙ</option>
            <option value="critical">КРИТИЧЕСКИЙ</option>
          </select>
        </div>
      </div>

      <div className="form-group">
        <label>ПОДРОБНОЕ ОПИСАНИЕ ИДЕИ</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="ЧТО ВЫ ПРЕДЛАГАЕТЕ?"
          required
        />
      </div>

      <div className="form-group">
        <label>ПОЛЬЗА ДЛЯ ПРОЕКТА</label>
        <textarea
          name="benefits"
          value={formData.benefits}
          onChange={handleChange}
          placeholder="ПОЧЕМУ ЭТО СДЕЛАЕТ MyUgc ЛУЧШЕ?"
        />
      </div>

      <div className="feedback-form-actions">
        <button type="submit" className="feedback-submit-btn" disabled={loading}>
          {loading ? 'ОТПРАВКА...' : '💡 ОТПРАВИТЬ ИДЕЮ'}
        </button>
      </div>

      {status.message && (
        <div className={`feedback-status-msg ${status.type}`}>
          {status.message}
        </div>
      )}
    </form>
  );
};

export default SuggestionForm;
